export default "__VITE_ASSET__63463aef__"